<template>

</template>

<script>
    export default {
        name: "FieldsNone",
        mounted() {
            this.$store.commit('setPaymentMethodData',{
                valid: true,
                data: {}
            });
        }
    }
</script>

<style scoped>

</style>
